// extracted by mini-css-extract-plugin
export default {"modal_overlay":"Modal_modal_overlay__QQ5y-","modal":"Modal_modal__pKHYR"};